module.exports = __webpack_public_path__ + "static/media/notification-uncheck.de81c7c6.svg";